/* import __COLOCATED_TEMPLATE__ from './subheader.hbs'; */
/**
`dialog-header/subheader` is mostly just a dumb block that can be
yielded out by parent components to allow consuming contexts to insert content
below the title and actions of a dialog header. Mostly used for rendering
navigation elements.

### Parameters
@param {Boolean} hasTabs - Optional flag to indicate this subheader contains tab navigation. Used to add custom styling class.
**/

import Component from '@ember/component';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  classNames: ['dialog__header__subheader'],
  classNameBindings: ['hasTabs:dialog__header__subheader--with-tabs']
});